import BaseModel from '@/app-core/lib/data/model/BaseModel'
import {pascalCase} from 'change-case'
import {toPascalCase} from '@/app-core/lib/utils/string'
import {clone} from '@/app-core/lib/utils/helper'
import API from '@/app-core/api/Api'
import ApiResponseEnum from '@/app-core/api/enums/ApiResponseEnum'

export default {
  name     : 'FormDataCommon',
  dataModel: BaseModel,
  data() {
    return {
      isFormSaving       : false,
      isFormValid        : false,
      formData           : null,
      showGenericError   : false,
      genericError       : '',
      serverErrorMessages: {}
    }
  },

  props: {
    item: {
      type   : [BaseModel, Object],
      default: undefined
    },
    itemViewMode: {
      type   : Boolean,
      default: false
    }
  },

  created() {
    this.initModel()
  },

  methods: {
    initModel(resetForm = false) {
      this.model = null
      this.$nextTick(() => {
        if (resetForm) this.resetForm()

        this.model = this.item && this.item instanceof BaseModel ? new this.item.constructor(this.item || {}) : this.$options.dataModel ? new this.$options.dataModel(this.item || {}) : new BaseModel(this.item || {})
        this.model.vueComponentInstance = this
        if (typeof this.clearServerErrorMessages === 'function') this.clearServerErrorMessages()
      })
    },

    resetForm() {
      if (this.modelForm) this.modelForm.reset()
    },

    resetFormValidation() {
      if (this.modelForm) this.modelForm.resetValidation()
    },

    validateForm(deep = true) {
      let retVal = false
      let frmValidate = false
      let modelValidate = false

      if (this.modelForm) frmValidate = this.modelForm.validate()
      if (this.model?.validator) modelValidate = deep ? this.model.validate() : this.model.validator.validate()

      retVal = frmValidate && modelValidate

      this.isFormValid = retVal

      Object.entries(this.model.errors).length && console.warn('VALIDATOR:: ', this.model.validator.constructor.name, this.model.errors, this.model)

      return retVal
    },

    saveFromData(showSuccessNotification = false) {
      if (this.model && (typeof this.model?.UpdateOrCreate === 'function' || typeof this.model.Create === 'function')) {
        if (this.isFormSaving || !this.validateForm()) return
        if (typeof this.clearServerErrorMessages === 'function') this.clearServerErrorMessages()
        this.isFormSaving = true

        this.model[typeof this.model?.UpdateOrCreate === 'function' ? 'UpdateOrCreate' : 'Create']()
          .then(response => {
            this.handleFormSaveResponse(response, showSuccessNotification)
          })
          .catch(error => {
            this.handleFormSaveResponse(error.response)
          })
          .finally(() => {
            this.isFormSaving = false
          })
      } else {

        console.warn('CREATE YOUR OWN "saveFromData" FUNCTION IN YOUR COMPONENT OR IMPLEMENT/ADD "UpdateOrCreate" or "Create" FUNCTION IN YOUR MODEL')
      }
    },

    handleFormSaveResponse(response, showSuccessNotification = false) {
      const data = API.responseData(response) || {}
      // const errors = API.responseErrors(response) || {}
      const serverErrors = API.responseData(response)?.Messages || {}
      const status = response?.status
      const message = response?.data?.message || data?.Messages?.Error || data?.Messages?.Warning || data?.Messages?.Info

      if (API.isResponseSuccess(response)) {
        this.formSaveSuccess(data, showSuccessNotification)
      } else {
        if (status === ApiResponseEnum.VALIDATOR_ERROR) {
          this.formSaveError(message, true)
        } else if (status === ApiResponseEnum.GENERIC_ERROR) {
          this.setServerErrorMessages(serverErrors)
        } else {
          this.formSaveError(message, true)
        }
      }
    },

    formSaveSuccess(data, showSuccessNotification = false) {
      this.showGenericError = false
      this.genericError = ''
      this.$emit('form:save:success', data)
      if (typeof this.closeDialog === 'function') this.closeDialog()

      if (!showSuccessNotification) return

      this.$bus.$emit('app:show-notification', {
        body   : data?.Messages?.Success || this.$t('Common.Message.SaveSuccess.Title'),
        type   : 'success',
        icon   : 'mdi-check-circle',
        timeout: 5000
      })
    },

    formSaveError(error, isGenericError = false) {
      const errorMessage = error || this.$t('Common.Error.Generic')
      this.showGenericError = isGenericError && !!errorMessage || isGenericError || false
      this.genericError = isGenericError && errorMessage ? errorMessage : ''
      this.$emit('form:save:error', errorMessage)
    },

    setServerErrorMessages(messages) {
      for (const key in messages) {
        if (messages.hasOwnProperty(key)) {
          this.serverErrorMessages[key] = messages[key]
          this.serverErrorMessages[pascalCase(key)] = messages[key]
        }
      }
      this.formSaveError(messages)
    },

    clearServerErrorMessages() {
      this.showGenericError = false
      this.genericError = ''
      const tmpMessages = {}
      for (const key in this.serverErrorMessages) if (this.serverErrorMessages.hasOwnProperty(key)) tmpMessages[key] = []
      this.serverErrorMessages = clone(tmpMessages)
    },

    resetServerErrorMessage(fieldName) {
      this.serverErrorMessages && fieldName && delete this.serverErrorMessages[toPascalCase(fieldName)]
    }
  },

  computed: {
    isModelValid() {
      const retVal = this.model.validate()

      Object.entries(this.model.errors).length && console.warn('VALIDATOR:: ', this.model.validator.constructor.name, this.model.errors, this.model)

      return retVal
    },

    modelForm() {
      return this.$refs?.form || null
    },

    model: {
      get() {
        return this.formData
      },
      set(val) {
        this.formData = val
      }
    }
  }
}
